import React from 'react';
import { IconPhone, IconAt } from '@tabler/icons-react';
import { contactDetails } from '../../Data/data';

const CONTACTS = [
    { title: 'Email', label: contactDetails.email, href: `mailto:${contactDetails.email}`, icon: IconAt },
    { title: 'Phone or text', label: contactDetails.phoneDisplay, href: contactDetails.phoneHref, icon: IconPhone },
];

// Email and phone as links, so visitors on a phone can tap to write or call
export function ContactIconsList() {
    return (
        <div className='flex flex-col gap-5'>
            {CONTACTS.map(({ title, label, href, icon: Icon }) => (
                <a key={href} href={href} className='group flex items-center gap-4 no-underline'>
                    <span className='flex items-center justify-center w-11 h-11 shrink-0 rounded-full border border-solid border-zinc-700 text-zinc-400 transition-colors group-hover:border-white group-hover:text-white'>
                        <Icon size={20} />
                    </span>
                    <span className='flex flex-col'>
                        <span className='text-xs uppercase tracking-wider text-zinc-500'>{title}</span>
                        <span className='text-white group-hover:underline underline-offset-4'>{label}</span>
                    </span>
                </a>
            ))}
        </div>
    );
}
